import { Box } from '@material-ui/core';
import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';
const drawerWidth = 280;

export const Wrapper = styled(Box)``;

export const Body = styled(Box)`
  ${({ theme, hidesidenav, fullWidth }) => `
    box-sizing: border-box;
    min-width: ${hidesidenav === 'true' ? '100%' : '100%'};
    max-width: 1024px;
    width: 100%;
    // border: 1px solid red;
    // overflow: hidden;
    // margin: 1% auto;
    margin-left: ${hidesidenav === 'true' ? 'auto' : 'auto'};
    margin-right: ${hidesidenav === 'true' ? 'auto' : 'auto'};
    margin-top: ${hidesidenav === 'true' ? '0%' : '0%'};
    // margin-right: 16%;
    @media (max-width: 640px) {
      width: 100%;
       margin: 0px;
    }
    @media (min-width: 640px) and (max-width: 960px){
      width: 90%;
      // border: 1px solid orange;
      margin: 0px 10px;
    }
  `}
`;

export const useStyles = makeStyles((theme) => ({
  quickstartContainer: {
    position: 'fixed',
    right: 90,
    bottom: 30,
    '& .MuiButton-contained': {
      // background: theme.palette.secondary.main,
      background: '#f5f5f5',
      boxShadow: '0 5px 4px 0 rgb(0 0 0 / 26%)',
      '& .MuiButton-label': {
        color: '#444444'
      }
    }
  },
  quickStart: {
    background: theme.palette.secondary.main,
    borderRadius: '50px',
    color: 'white'
  },
  quickstartWrapper: {
    overflow: 'scroll',
    height: '400px',
    '& .Mui-expanded': {
      margin: '0px'
    },
    '& .MuiAccordionSummary-root': {
      padding: '0px 15px'
    },
    '& .MuiAccordionDetails-root': {
      flexDirection: 'column',
      alignItems: 'flex-start',
      padding: '2px 20px 15px'
    },
    '& .MuiPaper-elevation0': {
      position: 'relative',
      height: 'auto',
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start',
      padding: '2em 10px',
      background: 'transparent'
    },
    '& a': {
      color: theme.palette.secondary.main,
      textDecoration: 'none',
      fontSize: '14px',
      fontWeight: 'bold',
      padding: '1em 0px',
      '&:hover': {
        textDecoration: 'underline'
      }
    }
  },
  stepGuide: {
    marginRight: '.5em'
  },
  dismiss: {
    position: 'fixed',
    bottom: 15,
    right: 70
  },
  drawerPaper: {
    position: 'fixed',
    overflow: 'hidden',
    width: drawerWidth,
    zIndex: '99999px',
    top: 76,
    background: '#f4f5f7'
  },
  quickstartHeader: {
    background: theme.palette.secondary.main,
    width: '100%',
    height: '25%',
    padding: '1.5em 1.2em',
    textAlign: 'center'
  },
  header: {
    padding: '3em 0px',
    textAlign: 'center',
    '& .MuiTypography-h5': {
      color: 'white',
      fontStyle: 'normal',
      fontWeight: 400,
      textAlign: 'center',
      fontSize: '22px'
    }
  },
  heading: {
    fontSize: '13px'
  },
  body: {
    fontSize: '12px',
    textAlign: 'left'
  }
}));
